import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  DialogContent,
  Grid2 as Grid,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import {
  defaultState,
  Actions,
  useDispatchProvider,
  useStateDrawerCustomerOrdersFilters,
  useStateFiltersCustomerOrders,
} from '../utils/StateProvider';
import FieldDate from '../fields/FieldDate';
import FieldSelect from '../fields/FieldSelect';
import { orderStatuses } from '../../data/statuses';
import FieldCheckbox from '../fields/FieldCheckbox';
import { useRole } from '../utils/AclProvider';

const DrawerCustomerOrdersFilters = () => {
  const role = useRole();
  const stateDrawerCustomerOrdersFilters = useStateDrawerCustomerOrdersFilters();
  const stateFiltersCustomerOrders = useStateFiltersCustomerOrders();
  const { handleSubmit, setValue, reset, control } = useForm({
    defaultValues: stateFiltersCustomerOrders,
  });
  const dispatch = useDispatchProvider();
  const handleDrawerClose = () => {
    dispatch && dispatch({ type: Actions.DrawerCustomerOrdersFilters, payload: false });
  };

  const sortingOrder = [
    { name: 'Asc', value: 'asc' },
    { name: 'Desc', value: 'desc' },
  ];

  const sortingFields = [
    { name: 'Status', value: 'orderStatus' },
    { name: 'Date created', value: 'dateCreated' },
  ];

  const onSubmit = (data) => {
    dispatch && dispatch({ type: Actions.FiltersCustomerOrders, payload: data });
    dispatch && dispatch({ type: Actions.DrawerCustomerOrdersFilters, payload: false });
  };

  useEffect(() => {
    reset(stateFiltersCustomerOrders);
  }, [stateFiltersCustomerOrders, reset]);

  const handleReset = () => {
    dispatch && dispatch({ type: Actions.FiltersOrder, payload: defaultState.filters.filtersCustomerOrders });
    dispatch && dispatch({ type: Actions.DrawerCustomerOrdersFilters, payload: false });
  };

  const filteredOrderStatuses = role !== 'admin' ? orderStatuses.filter((st) => st.value !== 'unpaid') : orderStatuses;

  return (
    <Drawer
      open={stateDrawerCustomerOrdersFilters}
      onClose={handleDrawerClose}
      anchor={'right'}
      color={'background'}
    >
      <AppBar position={'sticky'}>
        <Toolbar>
          <IconButton
            autoFocus
            size="large"
            edge="start"
            color="inherit"
            aria-label="close"
            sx={{ mr: 2 }}
            onClick={handleDrawerClose}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Customer orders filters
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ width: '336px', height: '100vh' }}>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Grid
            container
            spacing={3}
          >
            <Grid size={12}>
              <Typography variant={'subtitle1'}>Search filters</Typography>
            </Grid>
            <Grid size={12}>
              {/*<FieldDate*/}
              {/*  label={'Date created'}*/}
              {/*  name={'dateCreated'}*/}
              {/*  control={control}*/}
              {/*/>*/}
              <FieldDate
                label={'Date created'}
                name={'dateCreated'}
                control={control}
                setValue={setValue}
              />
            </Grid>
            <Grid size={12}>
              <FieldSelect
                label={'Status'}
                name={'orderStatus'}
                control={control}
                options={filteredOrderStatuses}
                setValue={setValue}
              />
            </Grid>
            <Grid size={12}>
              <Typography variant={'subtitle1'}>Ordering filters</Typography>
            </Grid>
            <Grid size={12}>
              <Grid
                container
                spacing={3}
              >
                <Grid size={7}>
                  <FieldSelect
                    label={'Field'}
                    name={'sortingField'}
                    control={control}
                    options={sortingFields}
                    disableClear={true}
                    setValue={setValue}
                  />
                </Grid>
                <Grid size={5}>
                  <FieldSelect
                    label={'Order'}
                    name={'sortingOrder'}
                    control={control}
                    options={sortingOrder}
                    disableClear={true}
                    setValue={setValue}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <Typography variant={'subtitle1'}>Display columns</Typography>
            </Grid>
            <Grid size={12}>
              <Grid
                container
                spacing={0}
              >
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Date created'}
                    control={control}
                    name={'columns.dateCreated'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'User created'}
                    control={control}
                    name={'columns.userCreated'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Date updated'}
                    control={control}
                    name={'columns.dateUpdated'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'User updated'}
                    control={control}
                    name={'columns.userUpdated'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Date completed'}
                    control={control}
                    name={'columns.dateCompleted'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'User completed'}
                    control={control}
                    name={'columns.userCompleted'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Status'}
                    control={control}
                    name={'columns.orderStatus'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Transaction'}
                    control={control}
                    name={'columns.orderTransaction'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Products'}
                    control={control}
                    name={'columns.products'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Total'}
                    control={control}
                    name={'columns.total'}
                    disabled={true}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Down Payment'}
                    control={control}
                    name={'columns.downPayment'}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCheckbox
                    label={'Comments'}
                    control={control}
                    name={'columns.comments'}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant={'text'}
          color={'primary'}
          onClick={handleReset}
        >
          Reset
        </Button>
        <Button
          variant={'contained'}
          color={'primary'}
          type={'submit'}
          onClick={handleSubmit(onSubmit)}
        >
          Apply
        </Button>
      </DialogActions>
    </Drawer>
  );
};

export default DrawerCustomerOrdersFilters;
